var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"breakpoints-container"},_vm._l((_vm.options),function(option,index){return _c('div',{key:index,staticClass:"breakpoint",class:{
      selected: option.numberOfMonths === _vm.selectedNumberOfMonths,
      disabled: !option.isPossible,
    },on:{"click":function($event){return _vm.selectOption(option)}}},[_vm._v(" "+_vm._s(option.label)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }